export const PRICING_DETAIL_MODULE_TEST_ID = {
  main: 'pricing-detail-main-section',
  hero: 'pricing-detail-hero-section',
  back: 'pricing-detail-back-link',
  content: 'pricing-detail-content-section',
};
